/**
 * =============================================================================
 * geo-product-bnpl.js 
 * =============================================================================
 * Show or hide BNPL options based on country. Was previously an FR feature
 * =============================================================================
 */

var GeoProductBNPL = {

  onReady: function(){
    // Only on product page
    if(!MP.Utilities.isProductPage()){
      return;
    }
    document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this));
  },

  handleGeodataLoaded: function(event) {
    var geodataJSON = event.detail.data;
    var isoCode = geodataJSON.country.iso_code;

    document.querySelectorAll(".product-payment-alt-options-container").forEach(function(element){
      var includedCountries = element.dataset.includedCountries.split(",");
      if(includedCountries.includes(isoCode)){
        console.log("[G-P-B] Included: animating in");
        element.classList.add('fade-in');
      } else {
        console.log("[G-P-B] Excluded: removing element");
        element.remove();
      }
    });
  }
};

export default GeoProductBNPL